import axios from "axios";
import { useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";

export const useRegistration = () => {
  const {
    state: { isForgetPassword, loginWithOTP },
  } = useLocation();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [hasError, setHasError] = useState(false);

  const { state } = useLocation();

  const navigate = useNavigate();

  const form = useForm({
    defaultValues: {
      phone: "",
      email: "",
      countryCode: "+91",
    },
  });

  const onSubmit = async (value: any) => {
    setIsLoading(true);
    if (hasError) {
      setIsLoading(false);
      toast.error("Please enter a valid phone number.");
      return;
    }
    await axios
      .post(
        `${process.env.REACT_APP_BASE_URL}/otp/${value?.countryCode}-${value?.phone}/${loginWithOTP || isForgetPassword ? "send_otp" : "send"}/`,
        {
          email: value?.email,
        },
      )
      .then(() => {
        setIsLoading(false);
        navigate("/login/opt-login", {
          state: {
            ...state,
            phone: value.phone,
            email: value.email,
            countryCode: value?.countryCode,
          },
        });
        toast.success("OTP sent successfully.");
      })
      .catch((error) => {
        setIsLoading(false);
        toast.error(
          error?.response?.data?.message ||
            "Something went wrong, please try again.",
        );
      });
  };

  return {
    isLoading,
    navigate,
    form,
    onSubmit,
    hasError,
    setHasError,
  };
};
